var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarehouseFull = function SvgWarehouseFull(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "currentColor"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#warehouse-full_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.31 5a.79.79 0 0 0-.62 0L2.58 10.52c-.595.25-.98.83-.98 1.475V28c0 .44-.36.8-.8.8S0 28.44 0 28V11.995c0-1.29.77-2.45 1.96-2.95l13.11-5.52a2.41 2.41 0 0 1 1.865 0l13.105 5.52c1.185.5 1.96 1.66 1.96 2.95V28c0 .44-.36.8-.8.8s-.8-.36-.8-.8V11.995c0-.645-.385-1.225-.98-1.475zM4.8 14.4c0-.885.715-1.6 1.6-1.6h19.2c.885 0 1.6.715 1.6 1.6V28c0 .44-.36.8-.8.8s-.8-.36-.8-.8V14.4H6.4V28c0 .44-.36.8-.8.8s-.8-.36-.8-.8zm12.8 8.8v4h4c.44 0 .8-.36.8-.8V24c0-.44-.36-.8-.8-.8zm-1.6 4v-4H9.6v3.2c0 .44.36.8.8.8zm0-8.8c0-.44-.36-.8-.8-.8h-4.8c-.44 0-.8.36-.8.8v3.2H16zm5.6 3.2A2.4 2.4 0 0 1 24 24v2.4a2.4 2.4 0 0 1-2.4 2.4H10.4A2.4 2.4 0 0 1 8 26.4v-8a2.4 2.4 0 0 1 2.4-2.4h4.8a2.4 2.4 0 0 1 2.4 2.4v3.2h4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "warehouse-full_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
};
export default SvgWarehouseFull;